function onClicked(evt) {
	var siblings = this.parentElement.parentElement.querySelectorAll("[data-toggle='tab']");

	Array.from(siblings).forEach(sib => {
		sib.parentElement.classList.remove("active");

		document.querySelector(sib.getAttribute("href")).classList.remove("active");

	});

	document.querySelector(this.getAttribute("href")).classList.add("active");
	this.parentElement.classList.add("active");

	evt.preventDefault();
}

module.exports = {
	init() {
		var toggles = document.querySelectorAll("[data-toggle='tab']");

		Array.from(toggles).forEach(toggle => {
			toggle.addEventListener("click", onClicked);
		});
	}
}